// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CallOwner_wrapper__1XKXx","owner":"CallOwner_owner__2oOMC"};